(() => {
  function initializeArchive(archive) {
    if (archive.dataset.initialized) return;
    archive.dataset.initialized = 'true';
    const files = [...archive.querySelectorAll('.trial-file')];
    const links = [...archive.querySelectorAll('.trial-index__link')];

    function selectFile(hash, focus = false) {
      const selected = files.find(file => `#${file.id}` === hash);
      if (!selected) return;
      selected.open = true;
      links.forEach(link => {
        if (link.hash === hash) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
      if (focus) selected.querySelector('summary').focus({ preventScroll: true });
    }

    links.forEach(link => link.addEventListener('click', () => selectFile(link.hash, true)));
    window.addEventListener('hashchange', () => selectFile(window.location.hash));
    selectFile(window.location.hash || links[0]?.hash);

  }
  document.querySelectorAll('[data-trial-archive]').forEach(initializeArchive);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-trial-archive]').forEach(initializeArchive);
  });
})();
